module.exports = __webpack_public_path__ + "img/back-redirect.7436f77e.webp";